import { InjectionToken } from '@angular/core';

export const ICON_SET_TOKEN = new InjectionToken('Icon Set Token');
